// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"e7ee099d","888":"5a2ec480","900":"e7ee099d"}[chunkId] + ".chunk.css";
};